module.exports = __webpack_public_path__ + "media/Radio Tonkuhle 11.04.2016.62c432e2.mp3";